// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Meditation Mode Component
// ═══════════════════════════════════════════════════════════════════════════
// Full-screen meditation overlay for focused reflection on a verse
// ═══════════════════════════════════════════════════════════════════════════

import { icons } from './icons.js';
import { logMeditationStart, logMeditationEnd } from '../services/analytics.js';
import { escapeHtml } from '../utils/escape.js';

let currentOverlay = null;
let meditationStartTime = null;
let currentVerse = null;

export function showMeditationMode(verse) {
  // Defensive cleanup - remove any existing overlay first
  const existingOverlay = document.getElementById('meditation-overlay');
  if (existingOverlay) {
    existingOverlay.remove();
  }

  // Clear any stale timer
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
  currentOverlay = null;

  currentVerse = verse;
  meditationStartTime = Date.now();

  const overlay = document.createElement('div');
  overlay.className = 'meditation-overlay';
  overlay.id = 'meditation-overlay';

  overlay.innerHTML = `
    <div class="meditation-container">
      <div class="meditation-backdrop"></div>
      
      <div class="meditation-content">
        <div class="meditation-verse-card">
          <div class="meditation-quote-mark">"</div>
          <p class="meditation-verse-text">${escapeHtml(verse.text)}</p>
          <span class="meditation-verse-reference">${escapeHtml(verse.reference)}</span>
        </div>
        
        <div class="meditation-timer" id="meditation-timer">
          <span class="meditation-timer-value">0:00</span>
        </div>
        
        <div class="meditation-breathing">
          <div class="meditation-breathing-circle"></div>
          <span class="meditation-breathing-text">Breathe...</span>
        </div>
      </div>
      
      <button class="meditation-close-btn" id="meditation-close">
        ${icons.x}
        <span>Finished</span>
      </button>
    </div>
  `;

  document.body.appendChild(overlay);
  currentOverlay = overlay;

  // Setup close handler
  overlay.querySelector('#meditation-close').addEventListener('click', hideMeditationMode);


  // Animate in
  requestAnimationFrame(() => {
    overlay.classList.add('active');
  });

  // Log meditation start
  logMeditationStart(verse.reference);

  // Start timer
  startMeditationTimer();

  //// Setup close handler
  // overlay.querySelector('#meditation-close').addEventListener('click', hideMeditationMode);

  // ESC key to close
  const handleEsc = (e) => {
    if (e.key === 'Escape') {
      hideMeditationMode();
      document.removeEventListener('keydown', handleEsc);
    }
  };
  document.addEventListener('keydown', handleEsc);
}

let timerInterval = null;

function startMeditationTimer() {
  const timerEl = currentOverlay?.querySelector('.meditation-timer-value');
  if (!timerEl) return;

  timerInterval = setInterval(() => {
    const elapsed = Math.floor((Date.now() - meditationStartTime) / 1000);
    const minutes = Math.floor(elapsed / 60);
    const seconds = elapsed % 60;
    timerEl.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }, 1000);
}

export function hideMeditationMode() {
  if (!currentOverlay) return;

  // Log meditation end with duration
  if (currentVerse && meditationStartTime) {
    const duration = Date.now() - meditationStartTime;
    logMeditationEnd(currentVerse.reference, duration);
  }

  // Clear timer
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }

  // Animate out
  currentOverlay.classList.remove('active');
  setTimeout(() => {
    currentOverlay?.remove();
    currentOverlay = null;
    currentVerse = null;
    meditationStartTime = null;
  }, 400);
}

export function isMeditating() {
  return currentOverlay !== null;
}

export default { showMeditationMode, hideMeditationMode, isMeditating };
